import classNames from 'classnames';
import { IconArrowSquareLeft } from '@/components/svg-symbols/icons';
import { PaginationArrowSize } from './type';
import { IconArrowRight2 } from '../icons';
const getClassName = (size: PaginationArrowSize) => classNames('rounded-md flex items-center justify-center', {
  'h-8 w-8 text-body-16': size === 'large',
  'h-6 w-6 text-body-14': size !== 'large'
});
interface Props {
  className?: string;
  size: PaginationArrowSize;
  onClick?: () => void;
}
export const PaginationNextArrow = ({
  className,
  size,
  onClick
}: Props) => {
  return <IconArrowSquareLeft className={classNames(getClassName(size), className)} onClick={onClick} data-sentry-element="IconArrowSquareLeft" data-sentry-component="PaginationNextArrow" data-sentry-source-file="arrows.tsx" />;
};
export const PaginationBackArrow = ({
  className,
  size,
  onClick
}: Props) => {
  return <IconArrowRight2 className={classNames(getClassName(size), className)} onClick={onClick} data-sentry-element="IconArrowRight2" data-sentry-component="PaginationBackArrow" data-sentry-source-file="arrows.tsx" />;
};